import { postRequest, publicPostRequest } from './api';

const authApi = {
  // --- Email & Password ---
  async login(email, password) {
    return publicPostRequest('/login', { email, password });
  },
  async register(userData) {
    return publicPostRequest('/register', userData);
  },

  // --- Email verification ---
  async verifyEmail(verificationCode) {
    return postRequest('/verify-email', { verification_code: verificationCode });
  },
  async requestVerificationCode() {
    return postRequest('/request-verification-code');
  },

  // -- Password Reset ---
  async forgotPassword(email) {
    return postRequest('/user/forgot-password', { email });
  },
  async resetPassword(token, new_password) {
    return postRequest('/user/reset-password', { token, new_password });
  },
};

export default authApi;
